"use client";
import { useEffect } from "react";
import { useEditor, type JSONContent } from "novel";
import { useStorage } from "@/lib/storage/provider";

export default function EmbedBridge({
  onOpen,
}: {
  onOpen: (id: string | null, json: JSONContent) => void;
}) {
  const { editor } = useEditor();
  const { adapter } = useStorage();

  useEffect(() => {
    const handler = async (e: MessageEvent) => {
      const d = e.data as { type?: string; id?: string; text?: string };
      if (!d || typeof d !== "object") return;
      if (d.type === "ploom:open-id" && d.id) {
        try {
          const doc = await adapter.read(d.id);
          if (doc) onOpen(doc.id, doc.json as JSONContent);
        } catch {}
        return;
      }
      if (d.type === "ploom:open-markdown" && typeof d.text === "string") {
        try {
          const node = editor?.storage?.markdown?.parser?.parse(d.text);
          if (node) onOpen(null, node.toJSON() as JSONContent);
        } catch {}
        return;
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [editor, adapter, onOpen]);

  return null;
}

